module.exports = __webpack_public_path__ + "static/shotlists_takes-7a7c353d51c89303db33e7e6646830aa.png";